/**
 * Automatické štítky zboží (jako na Shoptetu).
 *
 * Počítají se z dat, která dlaždice i detail už mají – žádné ruční příznaky:
 *   - „Novinka" = založeno v posledních 30 dnech,
 *   - „Poslední kusy" = málo skladem, ale ne vyprodáno.
 *
 * Sleva se ukazuje zvlášť (přeškrtnutá cena a −X %), tady se nezdvojuje.
 */

const NEW_DAYS = 30;
const LOW_STOCK_MAX = 3;

/** Je produkt „Novinka"? Rozbité datum bereme jako „ne", ne jako pád. */
export function isNew(createdAt: string): boolean {
  const created = Date.parse(createdAt);
  if (Number.isNaN(created)) return false;
  return Date.now() - created < NEW_DAYS * 24 * 60 * 60 * 1000;
}

/** „Poslední kusy" – 1 až 3 skladem. Vyprodáno (0) sem nepatří. */
export function isLowStock(available: number): boolean {
  return available > 0 && available <= LOW_STOCK_MAX;
}
